import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter, Observable, of, switchMap, tap } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const authService = inject(AuthService);

  if (authService.isLocalMode()) return of(true);

  return authService.isDoneLoading$.pipe(
    filter((isDone) => isDone),
    switchMap((_) => authService.isAuthenticated$),
    tap((isAuthenticated) => isAuthenticated || authService.login(state.url))
  );
};
